import { Bebidas } from "../../components";

export const CategoriaBebidas = () => <Bebidas />;
